var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6072 19.1976C14.4226 20.253 13.1293 20.0864 11.8842 19.5864C10.5667 19.0754 9.35792 19.0532 7.96785 19.5864C6.22724 20.2752 5.30858 20.0752 4.26905 19.1976C-1.62969 13.6094 -0.759383 5.09936 5.93714 4.78828C7.56896 4.86605 8.7052 5.6104 9.66012 5.67706C11.0864 5.41043 12.4523 4.64386 13.9754 4.74385C15.8006 4.87716 17.1786 5.54374 18.0852 6.74359C14.3138 8.82111 15.2083 13.3872 18.6654 14.6648C17.9764 16.3313 17.0819 17.9866 15.5951 19.2087L15.6072 19.1976ZM9.53924 4.72163C9.35792 2.24416 11.5458 0.199975 14.06 0C14.4105 2.8663 11.2315 4.99937 9.53924 4.72163Z",
    fill: "#0C1101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.19625859c4f7d45c5175b7b1225974c3.svg";
export { ForwardRef as ReactComponent };